module.exports = __webpack_public_path__ + "static/media/Orange_Timer@3x.cedfdeff.png";